import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("mt_token");
  const o = localStorage.getItem("mt_org");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  if (o) c.headers["X-Org-Id"] = o;
  return c;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Please check the form fields.";
  return e?.message || "Something went wrong";
};

export const fmt = (n) => (typeof n === "number" ? n.toLocaleString("en-US") : n);
export const money = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export const REASONS = {
  business_suspended: "This business is suspended in Morr Access.",
  business_closed: "This business is closed in Morr Access.",
  no_active_plan: "This business has no active Morr Translate plan.",
  business_not_found: "This business wasn't found in Morr Access.",
  included_words_used: "Included words used up; extra usage is off for this plan.",
};
export const reasonText = (r) => REASONS[r] || r || "Access is paused for this business.";
